<template>
    <div  class="w-full h-[150%] fixed top-0 left-0 bg-[#00000063] z-30 backdrop-blur-[2px]"></div>
        <div class="flex fixed justify-center top-[20%] bottom-[20%]  left-[3%] right-[3%] xl:left-[10%] xl:right-[10%] items-center z-40">
            <div class="flex flex-col justify-center  z-40 bg-white w-[700px] md:w-[800px] lg:w-[1000px] text-lg rounded-lg relative overflow-hidden">
                <div class="pafcpic_header bg-[#016B00] px-4 py-3 lg:py-3 lg:px-6">
                    <div class="flex justify-between">
                        <div>
                            <p class="text-[#ffffff] font-bold uppercase text-[12px] md:text-[15px] lg:text-[18px]">Training Requisition Request Form</p>
                        </div>
                        <div>
                            <p class="text-[#ffffff] font-bold uppercase text-[12px] md:text-[15px] lg:text-[18px] hover:text-[#c9c9c9d2]" @click="$emit('close')">X</p>
                        </div>
                    </div>
                </div>
                <div class="pafcpic_body py-3 px-5 lg:py-6 lg:px-10 overflow-y-auto">
                    <p class="text-[#016B00] text-xs lg:text-sm">Reference No.</p>
                    <p class="text-[#016B00] font-semibold text-lg md:text-xl lg:text-2xl">{{ data.ref_no }}</p>
                    <div class="grid grid-cols-2 lg:grid-cols-4 gap-2 lg:gap-5 mt-4 max-sm:text-sm ">
                        <div>
                            <p class="text-xs lg:text-sm text-[#7a7a7a]">Employee Name</p>
                            <p class="font-semibold text-[#686868] text-[0.95rem] lg:text-sm leading-tight">{{ data.employee_name }}</p>
                        </div>
                       
                        <div>
                            <p class="text-xs lg:text-sm text-[#7a7a7a]">Training Category</p>
                            <p class="font-semibold text-[#686868] text-[0.95rem] lg:text-sm leading-tight">{{ data.training_category }}</p>
                        </div>
                        <div>
                            <p class="text-xs lg:text-sm text-[#7a7a7a]">Training Type</p>
                            <p class="font-semibold text-[#686868] text-[0.95rem] lg:text-sm leading-tight">{{ data.training_type }}</p>
                        </div>
                        <div>
                            <p class="text-xs lg:text-sm text-[#7a7a7a]">Date Submitted</p>
                            <p class="font-semibold text-[#686868] text-[0.95rem] lg:text-sm leading-tight">{{ data.date_submitted }}</p>
                        </div>
                    </div>
                    <div v-if="data.training_category == 'EMPLOYEE INITIATED TRAINING'" class="grid grid-cols-2 lg:grid-cols-8 gap-1 lg:gap-2 mt-1 max-sm:text-sm h-[250px] overflow-auto ">
                        <div class="col-span-8 rounded-md border border-[#cccccc] py-1 px-2">
                            <p class="text-xs lg:text-sm text-[#7a7a7a]">TOPIC OF THE TRAINING</p>
                            <p class="font-semibold text-[#686868] text-[0.95rem] lg:text-sm leading-tight break-words">{{ data.topic }}</p>
                        </div>
                        <div v-for="(data, index) in trainingdate" :key="index" class="col-span-9 border-dotted border-[#CBCBCB] border-[2px] rounded-md py-1 px-2 flex gap-3 bg-[#EAEAEA] justify-between w-full">
                            <div class="flex gap-3">
                                <div class="flex items-center justify-center">
                                    <div class="rounded-full bg-[#D9D9D9] w-9 h-9 flex items-center justify-center font-bold text-[#016B00]">
                                        {{ index + 1 }}
                                    </div>
                                </div>
                                <div>
                                    <p class="text-xs text-[#949494]">Schedule of the Training</p>
                                    <p class="text-[#016B00] font-semibold max-sm:text-xs">{{ formatDate(data.fromdate) }} - {{ formatDate(data.todate) }} | {{ formatTime(data.fromtime) }} - {{ formatTime(data.totime) }} </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-span-4 rounded-md border border-[#cccccc] py-1 px-2">
                            <p class="text-xs lg:text-sm text-[#7a7a7a]">Training Location/ Venue</p>
                            <p class="font-semibold text-[#686868] text-[0.95rem] lg:text-sm leading-tight break-words">{{ data.location }}</p>
                        </div>
                        <div class="col-span-4 rounded-md border border-[#cccccc] py-1 px-2">
                            <p class="text-xs lg:text-sm text-[#7a7a7a]">Training Provider</p>
                            <p class="font-semibold text-[#686868] text-[0.95rem] lg:text-sm leading-tight break-words">{{ data.provider }}</p>
                        </div>
                        <div class="col-span-2 rounded-md border border-[#cccccc] py-1 px-2">
                            <p class="text-xs lg:text-sm text-[#7a7a7a]">Contact Person</p>
                            <p class="font-semibold text-[#686868] text-[0.95rem] lg:text-sm leading-tight uppercase break-words">{{ data.contact }}</p>
                        </div>
                        <div class="col-span-2 rounded-md border border-[#cccccc] py-1 px-2">
                            <p class="text-xs lg:text-sm text-[#7a7a7a]">Contact Details</p>
                            <p class="font-semibold text-[#686868] text-[0.95rem] lg:text-sm leading-tight break-words">{{ data.contact_no }}</p>
                        </div>
                        <div class="col-span-2 rounded-md border border-[#cccccc] py-1 px-2">
                            <p class="text-xs lg:text-sm text-[#7a7a7a]">Mode of Payment</p>
                            <p class="font-semibold text-[#686868] text-[0.95rem] lg:text-sm leading-tight break-words">{{ data.payment_mode }}</p>
                        </div>
                        <div class="col-span-2 rounded-md border border-[#cccccc] py-1 px-2">
                            <p class="text-xs lg:text-sm text-[#7a7a7a] ">Amount</p>
                            <p class="font-semibold text-[#686868] text-[0.95rem] lg:text-sm leading-tight break-words">{{ data.amount }}</p>
                        </div>
                        <div class="col-span-8">
                            <div class="grid grid-cols-3 gap-2">
                                <div class="col-span-1 rounded-md border border-[#cccccc] py-1 px-2">
                                    <p class="text-xs lg:text-sm text-[#7a7a7a]">Bank Name</p>
                                    <p class="font-semibold text-[#686868] text-[0.95rem] lg:text-sm leading-tight uppercase break-words">{{ data.bank }}</p>
                                </div>
                                <div class="rounded-md border border-[#cccccc] py-1 px-2">
                                    <p class="text-xs lg:text-sm text-[#7a7a7a]">Account Name</p>
                                    <p class="font-semibold text-[#686868] text-[0.95rem] lg:text-sm leading-tight uppercase break-words">{{ data.account_name }}</p>
                                </div>
                                <div class="rounded-md border border-[#cccccc] py-1 px-2">
                                    <p class="text-xs lg:text-sm text-[#7a7a7a]">Account Number</p>
                                    <p class="font-semibold text-[#686868] text-[0.95rem] lg:text-sm leading-tight break-words">{{ data.account_no }}</p>
                                </div>
                                <div class="rounded-md border border-[#cccccc] py-1 px-2">
                                    <p class="text-xs lg:text-sm text-[#7a7a7a]">Provider Registered Name</p>
                                    <p class="font-semibold text-[#686868] text-[0.95rem] lg:text-sm leading-tight uppercase break-words">{{ data.reg_name }}</p>
                                </div>
                                <div class="rounded-md border border-[#cccccc] py-1 px-2">
                                    <p class="text-xs lg:text-sm text-[#7a7a7a]">Service Provider Tin</p>
                                    <p class="font-semibold text-[#686868] text-[0.95rem] lg:text-sm leading-tight break-words">{{ data.tin }}</p>
                                </div>
                                <div class="rounded-md border border-[#cccccc] py-1 px-2">
                                    <p class="text-xs lg:text-sm text-[#7a7a7a]"> Provider Registration</p>
                                    <p class="font-semibold text-[#686868] text-[0.95rem] lg:text-sm leading-tight break-words">{{ data.reg_type }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-span-8 h-[170px]">
                            <div class="rounded-md border border-[#cccccc] py-1 px-2 h-full">
                                <p class="text-xs lg:text-sm text-[#7a7a7a]"> Special Instruction(s)</p>
                                <textarea v-model="sp_instruction" :readonly="true" class="overflow-auto h-[130px] outline-none resize-none w-full  text-[#686868] text-[0.95rem] font-semibold" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="border-t border-dashed border-[#a7a7a7]  mx-5"/>
                <div class="px-5 lg:px-10 max-h-[150px] overflow-auto">
                    <div class="flex gap-12 py-6">
                        <div class="flex flex-col gap-3">
                            <p class="text-xs font-medium text-[#595959]">Recommended by:</p>
                            <div v-for="(recon,index) in recommendation" :key="index" :class="{'text-[#016B00]': recon.status == 'A', 'text-[#7c807c]': !recon.date,'text-[#5a0202]': recon.status == 'D' }">
                                <p class=" font-medium" v-text="recon.employee_name"/>
                                <p class="text-xs"  v-text="recon.position_name"/>
                            </div>
                        </div>
                        <div class="flex flex-col gap-3">
                            <p class="text-xs font-medium text-[#595959]">Approved by:</p>
                            <div v-for="(approval,index) in approval" :key="index" :class="{'text-[#016B00]': approval.status == 'A', 'text-[#7c807c]': !approval.date,'text-[#5a0202]': approval.status == 'D' }">
                                <p class=" font-medium" v-text="approval.employee_name"/>
                                <p class="text-xs" v-text="approval.position_name"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pafcpic_footer flex gap-4 justify-end px-5 py-3 font-medium">
                    <button class="text-sm text-white bg-[#016B00] py-2 px-7 rounded-sm hover:bg-[#026b00bb] w-[150px]" v-if="apv && data.status == 'PROCESSED BY (OHR)' || data.status == 'PROCESSED BY (OHR)' || data.status == 'RECOMMENDED FOR APPROVAL (OHR)' || data.status == 'APPROVED BY (OHR)'"  @click="$emit('approve', data.ref_no, data.status)" >APPROVE</button>
                    <button class="text-sm text-white bg-[#016B00] py-2 px-7 rounded-sm hover:bg-[#026b00bb] w-[150px]" @click="$emit('viewpdf', data.ref_no)">VIEW PDF</button>
                    <button class="text-sm text-[#ffffff] bg-[#9b2b2b] py-2 px-7 rounded-sm  hover:bg-[#9b2b2bb0] w-[150px]" v-if="false" @click="$emit('disapprove', data.ref_no)">DISAPPROVE</button>
                    <button class="text-sm text-[#ffffff] bg-[#860000] py-2 px-7 rounded-sm hover:bg-[#5a0101] w-[200px]" v-if="data.status != 'CANCELLED' && data.status!='DISAPPROVED' && sign && cancel" @click="$emit('cancel', data.ref_no)">CANCEL REQUEST</button>
                </div>
        </div>
    </div>
</template>

<script>

import { defineComponent } from "vue"; 
import Training from "@/services/training";

export default defineComponent({
    components: {
       
    },
    data() {
        return {
            trainingdate:null,
            sp_instruction: null, 
            signatory: null,
            recommendation:'',
            approval:'',
            sign: false,
            ref_no:null,
        }
    },
    props: {
        data: {
            type: Object,
            default: null,
        },
        apv:{
            type : Boolean,
            default: false,
        },
        cancel:{
            type : Boolean,
            default: false,
        },
    },
    mounted(){
        this.sp_instruction = this.data.sp_instruction,
        this.ref_no = this.data.ref_no
        this.getSignatory()
    },
    methods:{
        formatDate(date) {
            return new Date(date).toLocaleString('en-US', {
                month: '2-digit',
                day: '2-digit',
                year: 'numeric'
            });
        },
        formatTime(time) {
            const today = new Date().toISOString().split('T')[0]; // YYYY-MM-DD
            return new Date(`${today} ${time}`).toLocaleTimeString('en-US', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            });
        },
        async getSignatory(){

            const success = await Training.getData(this.ref_no);
            this.signatory = success.data.data.training_signatory
            this.trainingdate = success.data.data.training_info
            if(this.signatory!=null ){

                this.recommendation = this.signatory.filter(signatory=>signatory.rank == 'R')
                this.approval       = this.signatory.filter(signatory=>signatory.rank == 'A')
                this.sign   = this.signatory.some(e=>e.date != null) ? false : true
                
                if(this.approval.length == 0){
                    this.approval = null
                }
            }
        },       
    }
})

</script>